import { createServerFn } from '@tanstack/react-start';
import type { OrderPayload } from '@/lib/types/order.types.ts';

const { VITE_LOCALE, VITE_API_URL } = import.meta.env;

export const getMainInfo = createServerFn({ method: 'GET' }).handler(async () => {
	const res = await fetch(
		`${VITE_API_URL}/HomePage/get-home-page-info/1/${VITE_LOCALE.toUpperCase()}`,
	);
	return res.json();
});

export const getServices = createServerFn({ method: 'GET' }).handler(async () => {
	const res = await fetch(
		`${VITE_API_URL}/CarService/get-car-services/1/${VITE_LOCALE.toUpperCase()}`,
	);
	return res.json();
});

export const getServicesWithSubServices = createServerFn({ method: 'GET' }).handler(async () => {
	const res = await fetch(
		`${VITE_API_URL}/CarService/get-car-services-with-sub-services/1/${VITE_LOCALE.toUpperCase()}`,
	);

	return res.json();
});

export const getServiceById = createServerFn({ method: 'GET' })
	.validator((data: { serviceId: string }) => data)
	.handler(async ({ data }: any) => {
		const { serviceId } = data;

		const res = await fetch(
			`${VITE_API_URL}/CarService/get-single-car-service-with-sub-services/1/${serviceId}/${VITE_LOCALE.toUpperCase()}`,
		);
		return res.json();
	});

export const getAvailableSlots = createServerFn({ method: 'GET' })
	.validator((data: { start: string; end: string }) => data)
	.handler(async ({ data }: any) => {
		const { start, end } = data;

		const res = await fetch(`${VITE_API_URL}/Calendar/get-calendar-availability/1/${start}&${end}`);
		return res.json();
	});

export const addOrder = createServerFn({ method: 'POST' })
	.validator((data: { payload: OrderPayload }) => data)
	.handler(async ({ data }) => {
		const { payload } = data;

		const res = await fetch(`${VITE_API_URL}/Order/add-order`, {
			method: 'POST',
			body: JSON.stringify(payload),
			headers: {
				'Content-Type': 'application/json',
			},
		});

		if (!res.ok && res.status === 400) {
			throw await res.text();
		}

		return res.json();
	});
